// extracted by mini-css-extract-plugin
module.exports = {"ecoCreditsDayBox":"ecocredits-day_ecoCreditsDayBox__Cy48Y"};